/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {DamExternalUpload} from 'compob2b-libs';
import {translations} from '../../../../environments/translations.ru';
import {CreateUpdateComponent} from '../../../admin-shared/crud-components/create-update/create-update.component';
import {CrudConfig} from '../../../admin-shared/interfaces/crud.config';
import {DAM_EXTERNAL_UPLOAD_FORM} from './dam-external-upload-forms.config';

@Component({
  templateUrl: './dam-external-upload.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DamExternalUploadComponent extends CreateUpdateComponent<DamExternalUpload> implements OnInit {
  @Input() damCatalog: number;

  shareUrl = '';
  title = 'Поделиться';
  protected uri = '/dam-external-upload';
  absolutePath = '/cabinet/dam-external-upload';
  isModal = true;

  config: CrudConfig = {
    uri: this.uri,
    columns: DAM_EXTERNAL_UPLOAD_FORM,
    title: this.title,
    absolutePath: this.absolutePath,
  };

  ngOnInit(): void {
    super.setConfig(this.config);
    super.ngOnInit();
    this.redirectToEditPage = true;
  }

  beforeSubmit(): void {
    super.beforeSubmit();
    this.entity.damCatalogId = this.damCatalog;
  }

  afterSubmit(): void {
    this.shareUrl = this.createdId;
    this.cdr.detectChanges();
  }

  copyShareUrl() {
    navigator.clipboard.writeText(this.shareUrl).then(_ => {
      this.successToast(translations.copiedToClipboard);
    });
  }
}
